import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
import {Divider} from 'antd'
import Title from 'antd/es/typography/Title'
import {getArtistStory} from '../../api/artistStories'
import HttpError from '../../component/base/HttpError'
import {getArtistBio} from '../../api/artistBio'
import {getArtistProfile} from '../../api/artistProfiles'
import IndexPage from '../../component/showcase/IndexPage'
import BrowserBorder from '../../component/showcase/BrowserBorder'
import ShowcasePreviewLayout from '../../component/showcase/ShowcasePreviewLayout'

@connect((state) => ({
    //decorator, gives component access to the state
    siderWidth: state.style.siderWidth,
    id: state.user.info.id,
    userId: state.user.info.userId,
    artistId: state.user.info.artistId,
    email: state.user.info.email,
    artistName: state.user.info.artistName
}))
class Index extends React.Component {
    constructor(props) {
        super(props)
        this.titleText = React.createRef()
        this.bioText = React.createRef()
        this.storyText = React.createRef()
        this.state = {
            profile: {},
            bio: {},
            story: {}
        }
    }

    componentDidMount() {
        getArtistProfile(this.props.artistId)
            .then((responseProfile) => {
                this.setState({
                    profile: {
                        avatar: responseProfile.data.avatar,
                        currVideo: responseProfile.data.video,
                        image: responseProfile.data.profile_image,
                        video: responseProfile.data.video
                    }
                })
            })
            .catch((error) => {
                HttpError(error)
            })

        getArtistStory(this.props.artistId)
            .then((response) => {
                this.setState({
                    story: {
                        title: response.data?.title,
                        body: response.data?.body
                    }
                })
                // this.loadStoryHandler();
            })
            .catch((error) => {
                HttpError(error)
            })

        getArtistBio(this.props.artistId)
            .then((responseArtistBio) => {
                if (responseArtistBio.data.body) {
                    //Able to store the rich text now, just need to load the body
                    this.setState({
                        bio: {
                            body: responseArtistBio?.data.body
                        }
                    })
                }
            })
            .catch((error) => {
                HttpError(error)
            })
    }

    render() {
        return (
            <ShowcasePreviewLayout {...this.props}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between'}}>
                    <div>
                        <Title style={{marginBottom: 0}}>Home page</Title>
                    </div>
                </div>
                <div/>
                <Divider/>
                <BrowserBorder {...this.props} hasPadding={false}>
                    <IndexPage {...this.props} profile={this.state.profile} bio={this.state.bio}
                               story={this.state.story}/>
                </BrowserBorder>
            </ShowcasePreviewLayout>
        )
    }
}

export default withRouter(Index)
